export const readDraft = key => {
  try {
    const value = JSON.parse(window.localStorage.getItem(key) || '{}');
    return value && typeof value === 'object' ? value : {};
  } catch (error) {
    return {};
  }
};

export const writeDraft = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify({
      name: typeof value?.name === 'string' ? value.name.slice(0, 2000) : '',
      activeStatus: Boolean(value?.activeStatus),
    }));
  } catch (error) {
    // Browser storage is optional; the form remains usable without it.
  }
};

export const clearDraft = key => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // Ignore storage errors after save or explicit discard.
  }
};
